export default {
  "settingsTargetSaved": "Objetivo guardado",
  "settingsVisual0": "Configura asignaciones, metas, tareas y secuencias para cada etapa guardada.",
  "settingsVisual1": "Define las etapas, los colores y los resultados de tu embudo.",
  "settingsVisual2": "Nombra cada etapa y elige su color y resultado.",
  "settingsVisual3": "Color",
  "settingsVisual4": "Color personalizado",
  "settingsVisual5": "etapas",
  "settingsVisual6": "Introduce nombres de etapas para ver la vista previa del embudo.",
  "settingsVisual7": "Todos los cambios guardados",
  "settingsVisual8": "Organiza tu proceso de ventas en etapas claras.",
  "settingsVisual9": "Establece una meta medible para tu equipo.",
  "settingsVisual10": "¿Guardar los cambios?",
  "settingsVisual11": "Todas las tareas del equipo, incluidas las no asignadas.",
  "settingsVisual12": "Solo las tareas que tienen asignadas.",
  "settingsVisual13": "Responsables: todas las tareas del equipo. Vendedores: solo sus propias tareas. Tareas sin asignar: solo responsables.",
  "settingsVisual14": "Acceso y asignación predeterminada",
  "settingsVisual15": "Las tareas sin asignar solo son visibles para los responsables.",
  "settingsVisual16": "Configura la asignación predeterminada y revisa el acceso según el rol de CRM.",
  "settingsVisual17": "Vista previa de asignación",
  "settingsVisual18": "Ejemplos de reglas; no son tareas reales.",
  "settingsVisual19": "Creador de la tarea apto",
  "settingsVisual20": "Responsable del contacto apto",
  "settingsVisual21": "El creador no cumple los requisitos",
  "settingsVisual22": "El responsable del contacto no cumple los requisitos",
  "settingsVisual23": "Miembro del personal",
  "settingsVisual24": "El acceso a las tareas no cambia.",
  "settingsVisual25": "Tendrá acceso a todas las tareas del equipo.",
  "settingsVisual26": "Solo verá sus propias tareas asignadas.",
  "settingsVisual27": "Personal seleccionado: {count}",
  "settingsVisual28": "Personal activo",
  "settingsVisual29": "Selección",
  "settingsVisual30": "Departamento · Puesto",
  "settingsVisual31": "Ya está en el equipo de ventas",
  "settingsVisual32": "Quitar selección",
  "settingsVisual33": "Elige tu equipo",
  "settingsVisual34": "Selecciona personal a la izquierda para revisar sus roles aquí.",
  "settingsVisual35": "Se retirará el acceso al CRM",
  "settingsVisual36": "La titularidad de los contactos es independiente de la asignación de tareas.",
  "settingsVisual37": "Trabajo para reasignar",
  "settingsVisual38": "No hay trabajo abierto para reasignar",
  "settingsVisual39": "El historial completado permanece con esta persona. Solo se puede transferir trabajo abierto.",
  "settingsVisual40": "Transferencia de responsabilidad",
  "settingsVisual41": "Tareas abiertas",
  "settingsVisual42": "Contactos potenciales activos",
  "settingsVisual43": "No hay trabajo abierto para transferir en esta sección.",
  "settingsVisual44": "Todo listo para quitar la pertenencia. Se conserva el historial.",
  "settingsVisual45": "Elige destinos para todo el trabajo abierto para continuar.",
  "settingsVisual46": "Añadir personal al equipo de ventas",
  "settingsVisual47": "Elige miembros del personal existentes y asigna su rol de CRM.",
  "settingsVisual48": "Revisa el acceso y transfiere el trabajo abierto antes de quitar la pertenencia.",
  "settingsVisual49": "Transfiere tareas abiertas y contactos activos conservando el historial completado.",
  "selectALeadToSeeAIInsightsAndSuggestions": "Selecciona un contacto para ver información y sugerencias de IA",
  "aIInsights": "Información de IA",
  "suggestedActions": "Acciones sugeridas:",
  "confidence": "Confianza:",
  "noActiveInsightsForThisLead": "No hay información activa para este contacto",
  "suggestedNextSteps": "Próximos pasos sugeridos",
  "timeline": "Plazo:",
  "aIEmailAssistant": "Asistente de correo con IA",
  "tone": "Tono:",
  "professional": "Profesional",
  "friendly": "Cercano",
  "formal": "Formal",
  "casual": "Informal",
  "generatedDraft": "Borrador generado:",
  "sendEmail": "Enviar correo",
  "copyToClipboard": "Copiar al portapapeles",
  "briefSummaryOfLeadSJourneyAndStatus": "Breve resumen del recorrido y estado del contacto",
  "mainTopicsDiscussedSoFar": "Principales temas tratados hasta ahora",
  "questionsToAskInNextInteraction": "Preguntas para la próxima interacción",
  "recommendedNextStep": "Próximo paso recomendado",
  "thingsToWatchOutForOrLeverage": "Aspectos que conviene tener en cuenta o aprovechar",
  "aIContactAssistant": "Asistente de contactos con IA",
  "analyzing": "Analizando...",
  "insights": "Información",
  "lastUpdated": "Última actualización:",
  "clickGenerateInsightsToGetAIPoweredLeadAnalysis": "Pulsa «Generar información» para obtener un análisis del contacto con IA",
  "analyzingLeadDataAndGeneratingInsights": "Analizando los datos del contacto y generando información...",
  "leadSummary": "Resumen del contacto",
  "keyDiscussionTopics": "Temas principales",
  "suggestedQuestions": "Preguntas sugeridas",
  "q": "P",
  "recommendedNextAction": "Próxima acción recomendada",
  "importantNotes": "Notas importantes",
  "failedToLoadLeads": "No se han podido cargar los contactos",
  "leadsUpdated": "Contactos actualizados",
  "failedToAddLeadsToPipeline": "No se han podido añadir los contactos al embudo",
  "allLeads": "Todos los contactos",
  "searchFilterAndManageLeadsAcrossAllPipelines": "Busca, filtra y gestiona contactos de todos los embudos.",
  "searchLeadsByNameOrEmail": "Buscar contactos por nombre o correo",
  "allPipelines": "Todos los embudos",
  "noPipelineAssigned": "Sin embudo asignado",
  "lead": "Contacto",
  "phone": "Teléfono",
  "source": "Origen",
  "pipeline": "Embudo",
  "stage": "Etapa",
  "statusTemp": "Estado / Prioridad",
  "lastActivity": "Última actividad",
  "created": "Creado",
  "noLeadsFound": "No se han encontrado contactos.",
  "page": "Página",
  "of": "de",
  "previous": "Anterior",
  "next": "Siguiente",
  "leadSSelected": "contacto(s) seleccionado(s)",
  "clearSelection": "Borrar selección",
  "addToPipeline": "Añadir al embudo",
  "selectAPipelineToMoveTheSelectedLeadsIntoTheFirstStage": "Selecciona un embudo para mover los contactos seleccionados a la primera etapa.",
  "chooseAPipeline": "Elige un embudo",
  "cancel": "Cancelar",
  "confirm": "Confirmar",
  "cRMAnalytics": "Análisis de CRM",
  "last7Days": "Últimos 7 días",
  "last30Days": "Últimos 30 días",
  "last90Days": "Últimos 90 días",
  "pipelineValue": "Valor del embudo",
  "activeDeals": "Operaciones activas",
  "winRate": "Tasa de éxito",
  "avgDealSize": "Valor medio de operación",
  "activeLeads": "Contactos activos",
  "conversionRate": "Tasa de conversión",
  "target": "Objetivo",
  "failedToLoadCRMSummary": "No se ha podido cargar el resumen de CRM.",
  "pipelineDistribution": "Distribución del embudo",
  "activityTrends": "Tendencias de actividad",
  "leadSourcePerformance": "Rendimiento por origen",
  "dealHealthOverview": "Estado de las operaciones",
  "healthyActive": "En buen estado (activas)",
  "stale14Weeks": "Sin actividad (1-4 semanas)",
  "atRisk30Days": "En riesgo (más de 30 días)",
  "dealsNeedImmediateAttention": "operaciones necesitan atención inmediata",
  "pipelineVelocityAvgDaysInStage": "Velocidad del embudo (media de días por etapa)",
  "avgDays": "Media de días",
  "status": "Estado",
  "selectAPipelineToViewLeads": "Selecciona un embudo para ver los contactos.",
  "failedToLoadLeadList": "No se ha podido cargar la lista de contactos.",
  "loadingLeads": "Cargando contactos…",
  "name": "Nombre",
  "company": "Empresa",
  "contact": "Datos de contacto",
  "priority": "Prioridad",
  "value": "Valor",
  "assignedTo": "Asignado a",
  "actions": "Acciones",
  "noLeadsFoundForThisPipeline": "No se han encontrado contactos en este embudo.",
  "loadingPipeline": "Cargando embudo…",
  "unableToDetermineClubContext": "No se ha podido determinar el club.",
  "noCRMPipelinesConfiguredYet": "Aún no hay embudos de CRM configurados.",
  "selectAPipelineToViewStages": "Selecciona un embudo para ver las etapas.",
  "failedToLoadPipelineData": "No se han podido cargar los datos del embudo.",
  "followUp": "Seguimiento:",
  "email": "Correo electrónico",
  "sMS": "SMS",
  "call": "Llamar",
  "noLeadsInThisStage": "No hay contactos en esta etapa",
  "selectSalesTeamMember": "Selecciona un miembro del equipo de ventas",
  "stageGoalsCanTBeSetOnTheFinalNonTerminalStage": "No se pueden establecer objetivos en la última etapa no terminal.",
  "taskType": "Tipo de tarea",
  "taskName": "Nombre de la tarea",
  "taskNote": "Nota de la tarea",
  "selectActiveSequence": "Selecciona una secuencia activa",
  "remove": "Eliminar",
  "save": "Guardar",
  "userAssignments": "Asignaciones de usuarios",
  "stageGoals": "Objetivos de etapa",
  "tasks": "Tareas",
  "sequences": "Secuencias",
  "editPipeline": "Editar embudo",
  "pipelineName": "Nombre del embudo",
  "loadingStages": "Cargando etapas…",
  "addStage": "Añadir etapa",
  "deletePipeline": "Eliminar embudo",
  "pipelines": "Embudos",
  "loadingPipelines": "Cargando embudos…",
  "stages": "Etapas",
  "sortOrder": "Orden",
  "edit": "Editar",
  "createPipeline": "Crear embudo",
  "loadingTarget": "Cargando objetivo…",
  "label": "Etiqueta",
  "annualMemberSignUps": "Altas anuales de socios",
  "goal": "Meta",
  "period": "Periodo",
  "annual": "Anual",
  "quarterly": "Trimestral",
  "monthly": "Mensual",
  "saveTarget": "Guardar objetivo",
  "saved": "Guardado.",
  "weeklyActivities": "Actividades semanales",
  "updated": "Actualizado:",
  "use": "Usar",
  "pleaseEnterAnAIPromptFirst": "Introduce primero una instrucción para la IA",
  "errorGeneratingContent": "Error al generar contenido",
  "templateName": "Nombre de la plantilla",
  "templateName2": "Nombre de la plantilla...",
  "type": "Tipo",
  "sharing": "Compartir",
  "private": "Privada",
  "team": "Equipo",
  "organization": "Organización",
  "subject": "Asunto",
  "emailSubject": "Asunto del correo...",
  "category": "Categoría",
  "categoryOptional": "Categoría (opcional)...",
  "aIContentAssistant": "Asistente de contenido con IA",
  "eGAFriendlyFollowUpAfterADemo": "P. ej., un seguimiento cordial después de una demostración...",
  "generate": "Generar",
  "content": "Contenido",
  "templateContentUseLeadFirstNameForMergeFields": "Contenido de la plantilla... Usa {{lead.firstName}} para los campos de combinación",
  "insertField": "Insertar campo:",
  "leadFirstName": "Nombre · lead.firstName",
  "leadLastName": "Apellidos · lead.lastName",
  "leadCompany": "Empresa · lead.company",
  "senderName": "Remitente · sender.name",
  "saveTemplate": "Guardar plantilla",
  "failedToLoadTemplates": "No se han podido cargar las plantillas",
  "errorSavingTemplate": "Error al guardar la plantilla",
  "templateDuplicated": "Plantilla duplicada",
  "errorDuplicatingTemplate": "Error al duplicar la plantilla",
  "templateArchived": "Plantilla archivada",
  "errorArchivingTemplate": "Error al archivar la plantilla",
  "emailTemplates": "Plantillas de correo",
  "createAndManageReusableTemplates": "Crea y gestiona plantillas reutilizables",
  "createTemplate": "Crear plantilla",
  "searchTemplates": "Buscar plantillas...",
  "allTypes": "Todos los tipos",
  "loadingTemplates": "Cargando plantillas...",
  "noTemplatesFound": "No se han encontrado plantillas",
  "createYourFirstTemplate": "Crea tu primera plantilla",
  "qualified": "Cualificado",
  "contactMade": "Contacto establecido",
  "tourScheduled": "Visita programada",
  "tourCompleted": "Visita completada",
  "proposalSent": "Propuesta enviada",
  "negotiating": "En negociación",
  "closedWon": "Ganada",
  "closedLost": "Perdida",
  "low": "Baja",
  "medium": "Media",
  "high": "Alta",
  "hot": "Muy alta",
  "setPriority": "Establecer prioridad",
  "setStage": "Establecer etapa",
  "overview": "Resumen",
  "activities": "Actividades (",
  "aIAssistant": "Asistente de IA",
  "notesTasks": "Notas y tareas",
  "contactInformation": "Información de contacto",
  "logActivity": "Registrar actividad",
  "convertToMember": "Convertir en socio",
  "convertedToMember": "Convertido en socio",
  "leadDetails": "Detalles del contacto",
  "referringMember": "Socio que recomienda",
  "membershipInterest": "Interés de afiliación",
  "timelineDates": "Plazos y fechas",
  "nextFollowUp": "Próximo seguimiento",
  "tourDate": "Fecha de visita",
  "notes": "Notas",
  "activityTimeline": "Historial de actividades",
  "noActivitiesRecordedYet": "Aún no hay actividades registradas",
  "addNote": "Añadir nota",
  "noNotesOrTasksYet": "Aún no hay notas ni tareas",
  "advancedFilters": "Filtros avanzados",
  "filterLeads": "Filtrar contactos",
  "clearAll": "Borrar todo",
  "dateAdded": "Fecha de incorporación",
  "allStaffMembers": "Todo el personal",
  "leadSource": "Origen del contacto",
  "allSources": "Todos los orígenes",
  "pipelineStage": "Etapa del embudo",
  "allStages": "Todas las etapas",
  "allPriorities": "Todas las prioridades",
  "pipelineType": "Tipo de embudo",
  "allPipelines2": "Todos los embudos",
  "membership": "Afiliación",
  "corporate": "Corporativo",
  "event": "Evento",
  "referral": "Recomendación",
  "estimatedValueRange": "Rango de valor estimado",
  "min": "Mín.",
  "to": "a",
  "max": "Máx.",
  "sourceEvent": "Evento de origen",
  "allEvents": "Todos los eventos",
  "applyFilters": "Aplicar filtros",
  "pleaseSelectACountryCode": "Selecciona un prefijo de país.",
  "pleaseEnterAPhoneNumber": "Introduce un número de teléfono.",
  "enterAValidPhoneNumberBetween8And15Digits": "Introduce un número de teléfono válido de entre 8 y 15 dígitos.",
  "firstName": "Nombre *",
  "lastName": "Apellidos *",
  "countryCode": "Prefijo de país",
  "allCountries": "Todos los países",
  "phoneNumber": "Número de teléfono",
  "pipeline2": "Embudo *",
  "selectPipeline": "Selecciona un embudo",
  "stage2": "Etapa *",
  "selectStage": "Selecciona una etapa",
  "source2": "Origen *",
  "selectSource": "Selecciona un origen",
  "website": "Sitio web",
  "advertising": "Publicidad",
  "socialMedia": "Redes sociales",
  "coldOutreach": "Contacto en frío",
  "other": "Otro",
  "membershipTypeInterest": "Tipo de afiliación de interés",
  "selectType": "Selecciona un tipo",
  "selectPriority": "Selecciona una prioridad",
  "leadValue": "Valor del contacto",
  "unassigned": "Sin asignar",
  "interests": "Intereses",
  "addInterestGolfTennisDiningEtc": "Añadir interés (golf, tenis, restauración, etc.)",
  "add": "Añadir",
  "tags": "Etiquetas",
  "addTag": "Añadir etiqueta",
  "connections": "Vínculos",
  "saveLeadFirstToAddConnections": "Guarda el contacto para añadir vínculos.",
  "connectionType": "Tipo de vínculo",
  "member": "Socio",
  "search": "Buscar",
  "select": "Seleccionar",
  "note": "Nota",
  "describeTheRelationship": "Describe la relación",
  "addConnection": "Añadir vínculo",
  "noConnections": "Sin vínculos",
  "leadSourceAnalytics": "Análisis de orígenes de contactos",
  "refreshData": "Actualizar datos",
  "totalSources": "Total de orígenes",
  "bestConversion": "Mejor conversión",
  "topSource": "Principal origen",
  "sourcePerformance": "Rendimiento por origen",
  "conversionRatesBySource": "Tasas de conversión por origen",
  "leadGenerationTrendsLast30Days": "Tendencias de captación (últimos 30 días)",
  "detailedSourcePerformance": "Rendimiento detallado por origen",
  "totalLeads": "Total de contactos",
  "avgValue": "Valor medio",
  "totalValue": "Valor total",
  "performance": "Rendimiento",
  "interest": "Interés",
  "interestedIn": "Interesado en:",
  "projectedValue": "Valor previsto:",
  "leadToMember": "De contacto a socio",
  "aNewMemberJoinsTheClub": "Un nuevo socio se une al club",
  "hasReachedClosedWonWouldYouLikeToOfficiallyCreateTheirMemberProfile": "ha llegado a la etapa ganada. ¿Quieres crear su perfil de socio?",
  "keepInClosedWon": "Mantener en etapa ganada",
  "followUp2": "Seguimiento",
  "noFollowUp": "Sin seguimiento",
  "noActiveLeadsFound": "No se han encontrado contactos activos",
  "logActivityFor": "Registrar actividad para",
  "activityType": "Tipo de actividad",
  "meeting": "Reunión",
  "tour": "Visita",
  "outcome": "Resultado",
  "selectOutcome": "Selecciona un resultado",
  "positive": "Positivo",
  "neutral": "Neutro",
  "negative": "Negativo",
  "noResponse": "Sin respuesta",
  "titleSubject": "Título / Asunto",
  "description": "Descripción",
  "sent": "Enviado",
  "openRate": "Tasa de apertura",
  "clickRate": "Tasa de clics",
  "bounced": "Rebotados",
  "scheduled": "Programado:",
  "created2": "Creado:",
  "recipients": "Destinatarios:",
  "audience": "Audiencia",
  "schedule": "Programación",
  "campaignTitle": "Título de la campaña",
  "internalCampaignName": "Nombre interno de la campaña",
  "campaignType": "Tipo de campaña",
  "broadcast": "Envío general",
  "dripCampaign": "Campaña por etapas",
  "leadNurture": "Desarrollo de contactos",
  "subjectLine": "Asunto",
  "emailSubjectLine": "Asunto del correo",
  "previewText": "Texto de vista previa",
  "textShownInEmailPreview": "Texto mostrado en la vista previa del correo",
  "fromName": "Nombre del remitente",
  "replyToEmail": "Correo de respuesta",
  "repliesYourclubCom": "replies@yourclub.com",
  "emailContent": "Contenido del correo",
  "emailHTMLContent": "Contenido HTML del correo...",
  "forPersonalization": "para personalizar",
  "targetAudience": "Público objetivo",
  "selectedFiltersWillTarget": "Los filtros seleccionados se aplicarán a",
  "leads": "contactos",
  "leadStages": "Etapas de contactos",
  "leadSources": "Orígenes de contactos",
  "priorityLevel": "Nivel de prioridad",
  "sendTimeOptional": "Hora de envío (opcional)",
  "leaveBlankToSendImmediately": "Deja el campo vacío para enviar inmediatamente",
  "loadingCampaigns": "Cargando campañas...",
  "marketingCampaigns": "Campañas de marketing",
  "createAndManageEmailCampaignsForYourLeads": "Crea y gestiona campañas de correo para tus contactos",
  "createCampaign": "Crear campaña",
  "noCampaignsYet": "Aún no hay campañas",
  "createYourFirstEmailCampaignToStartNurturingLeads": "Crea tu primera campaña de correo para desarrollar tus contactos",
  "createFirstCampaign": "Crear primera campaña",
  "campaignAnalytics": "Análisis de campaña -",
  "opened": "Abiertos",
  "clicked": "Clics",
  "close": "Cerrar",
  "failedToLoadProspects": "No se han podido cargar los prospectos",
  "addedToCRM": "Añadidos a CRM",
  "failedToAddProspectsToCRM": "No se han podido añadir los prospectos a CRM",
  "undoComplete": "Importación deshecha",
  "failedToUndoLastImport": "No se ha podido deshacer la última importación",
  "prospects": "Prospectos",
  "searchVisitorsAndAddThemToYourCRMPipeline": "Busca visitantes y añádelos a tu embudo de CRM.",
  "searchProspectsByNameOrEmail": "Buscar prospectos por nombre o correo",
  "undoLastImport": "Deshacer última importación",
  "addToCRM": "Añadir a CRM",
  "lastVisit": "Última visita",
  "totalVisits": "Total de visitas",
  "noProspectsFoundYet": "Aún no se han encontrado prospectos.",
  "salesRep": "Representante de ventas",
  "salesManager": "Responsable de ventas",
  "failedToLoadSalesTeam": "No se ha podido cargar el equipo de ventas",
  "failedToLoadStaff": "No se ha podido cargar el personal",
  "salesTeamMemberAdded": "Miembro del equipo de ventas añadido",
  "addFailed": "No se ha podido añadir",
  "updateFailed": "No se ha podido actualizar",
  "memberRemoved": "Miembro eliminado",
  "removeFailed": "No se ha podido eliminar",
  "salesTeam": "Equipo de ventas",
  "controlWhoCanBeAssignedCRMTasks": "Controla a quién se pueden asignar tareas de CRM.",
  "addTeamMember": "Añadir miembro al equipo",
  "teamMembers": "Miembros del equipo",
  "loadingSalesTeam": "Cargando equipo de ventas...",
  "noSalesTeamMembersYet": "Aún no hay miembros en el equipo de ventas.",
  "staff": "Personal",
  "jobTitle": "Puesto",
  "role": "Rol",
  "searchStaff": "Buscar personal",
  "searchByNameEmailTitle": "Buscar por nombre, correo o puesto",
  "selectAStaffMember": "Selecciona un miembro del personal",
  "selectAStepToEditItsProperties": "Selecciona un paso para editar sus propiedades",
  "onReplyActionS": "Acciones al responder",
  "createTask": "Crear tarea",
  "advanceStage": "Avanzar etapa",
  "title": "Título",
  "taskTitle": "Título de la tarea",
  "normal": "Normal",
  "assignee": "Responsable",
  "movesTheLeadToTheNextStageBySortOrder": "Mueve el contacto a la siguiente etapa según el orden establecido.",
  "emailTemplate": "Plantilla de correo",
  "selectTemplate": "Selecciona una plantilla...",
  "templateIsRequiredForSendEmailSteps": "Los pasos de envío de correo requieren una plantilla.",
  "body": "Cuerpo",
  "emailBody": "Cuerpo del correo...",
  "previewTemplate": "Vista previa de la plantilla",
  "stopOnReply": "Detener al responder",
  "yes": "Sí",
  "no": "No",
  "sMSTemplate": "Plantilla de SMS",
  "selectSMSTemplate": "Selecciona una plantilla de SMS...",
  "320Characters": "/320 caracteres",
  "duration": "Duración",
  "1Hour": "1 hora",
  "1Day": "1 día",
  "2Days": "2 días",
  "taskType2": "Tipo de tarea",
  "taskTitle2": "Título de la tarea",
  "taskTitle3": "Título de la tarea...",
  "dueInMinutes": "Vencimiento en minutos",
  "noPropertiesForThisStepType": "Este tipo de paso no tiene propiedades.",
  "stepProperties": "Propiedades del paso",
  "wait": "Esperar",
  "followUpCall": "Llamada de seguimiento",
  "sendSMS": "Enviar SMS",
  "pleaseEnterASequenceName": "Introduce un nombre para la secuencia",
  "sequenceSaved": "Secuencia guardada",
  "sequenceName": "Nombre de la secuencia...",
  "sequenceSteps": "Pasos de la secuencia",
  "enrollments": "Inscripciones",
  "conversion": "Conversión",
  "active": "Activa",
  "lastModified": "Última modificación:",
  "scope": "Ámbito:",
  "viewAnalytics": "Ver análisis",
  "errorLoadingSequences": "Error al cargar las secuencias",
  "errorDuplicatingSequence": "Error al duplicar la secuencia",
  "errorDeletingSequence": "Error al eliminar la secuencia",
  "errorLoadingSequenceDetails": "Error al cargar los detalles de la secuencia",
  "sequenceLibrary": "Biblioteca de secuencias",
  "createAndManageYourEmailSequences": "Crea y gestiona tus secuencias de correo",
  "createSequence": "Crear secuencia",
  "searchSequences": "Buscar secuencias...",
  "allStatus": "Todos los estados",
  "archived": "Archivada",
  "scope2": "Ámbito",
  "allScope": "Todos los ámbitos",
  "loadingSequences": "Cargando secuencias...",
  "noSequencesFound": "No se han encontrado secuencias",
  "createYourFirstSequence": "Crea tu primera secuencia",
  "stageChange": "Cambio de etapa",
  "fieldUpdate": "Actualización de campo",
  "timeBased": "Por tiempo",
  "manual": "Manual",
  "moveStage": "Mover etapa",
  "updateField": "Actualizar campo",
  "addTag2": "Añadir etiqueta",
  "notifyUser": "Notificar a un usuario",
  "workflowAutomation": "Automatización de flujos",
  "createAutomatedWorkflowsToStreamlineYourSalesProcess": "Crea flujos automatizados para agilizar tu proceso de ventas",
  "createWorkflow": "Crear flujo",
  "deleteWorkflow": "Eliminar flujo",
  "areYouSureYouWantToDelete": "¿Seguro que quieres eliminar «",
  "thisActionCannotBeUndone": "»? Esta acción no se puede deshacer.",
  "delete": "Eliminar",
  "trigger": "Activador:",
  "actions2": "Acciones:",
  "executions": "Ejecuciones:",
  "noWorkflowsYet": "Aún no hay flujos",
  "createYourFirstWorkflowToAutomateYourSalesProcess": "Crea tu primer flujo para automatizar tu proceso de ventas",
  "createFirstWorkflow": "Crear primer flujo",
  "workflowName": "Nombre del flujo *",
  "eGNewLeadWelcomeSequence": "P. ej., secuencia de bienvenida de nuevos contactos",
  "triggerType": "Tipo de activador *",
  "selectTrigger": "Selecciona un activador",
  "describeWhatThisWorkflowDoes": "Describe qué hace este flujo",
  "addAction": "Añadir acción",
  "action": "Acción",
  "actionType": "Tipo de acción",
  "templateNameOrSubject": "Nombre o asunto de la plantilla",
  "taskDescription": "Descripción de la tarea",
  "taskToCreate": "Tarea que se creará",
  "targetStage": "Etapa de destino",
  "noActionsAddedYetClickAddActionToGetStarted": "Aún no hay acciones. Pulsa «Añadir acción» para empezar.",
  "activateImmediately": "Activar inmediatamente",
  "assigneesUnavailable": "Responsables no disponibles",
  "tasksCanStillBeSavedAsUnassigned": "Las tareas se pueden guardar sin asignar.",
  "leadRequired": "Contacto obligatorio",
  "selectALeadBeforeCreatingATask": "Selecciona un contacto antes de crear una tarea.",
  "dueDateRequired": "Fecha de vencimiento obligatoria",
  "selectAValidDueDateAndTime": "Selecciona una fecha y hora de vencimiento válidas.",
  "taskRescheduled": "Tarea reprogramada",
  "taskCreated": "Tarea creada",
  "taskSaveFailed": "No se ha podido guardar la tarea",
  "planYourNextFollowUp": "Planifica el próximo seguimiento.",
  "lead2": "Contacto *",
  "searchByNameEmailPhone": "Buscar por nombre, correo o teléfono",
  "noResults": "Sin resultados.",
  "selectLead": "Seleccionar contacto",
  "title2": "Título *",
  "dueDateTime": "Fecha y hora de vencimiento *",
  "aM": "a. m.",
  "pM": "p. m.",
  "saveTask": "Guardar tarea",
  "taskWorkspace": "Espacio de tareas",
  "searchTasksLeads": "Buscar tareas o contactos",
  "refresh": "Actualizar",
  "newTask": "+ Nueva tarea",
  "today": "Hoy:",
  "overdue": "Vencidas:",
  "upcoming": "Próximas:",
  "completed": "Completadas:",
  "allAssignees": "Todos los responsables",
  "loadingTasks": "Cargando tareas...",
  "noTasksMatchYourFilters": "Ninguna tarea coincide con tus filtros.",
  "assigned": "Responsable",
  "undoCompletion": "Deshacer finalización",
  "markComplete": "Completar",
  "taskFocus": "Detalle de la tarea",
  "selectATaskToFocusYourNextAction": "Selecciona una tarea para centrar tu próxima acción.",
  "relatedLead": "Contacto relacionado",
  "reschedule": "Reprogramar",
  "openLead": "Abrir contacto",
  "allUnassigned": "Todos / Sin asignar",
  "noPhoneNumber": "Sin número de teléfono",
  "thisLeadDoesNotHaveAPhoneNumberOnFile": "Este contacto no tiene un número de teléfono registrado.",
  "cRMPermissionsAreUnavailable": "Los permisos de CRM no están disponibles.",
  "newLead": "Nuevo contacto",
  "pipeline3": "Embudo:",
  "assignee2": "Responsable:",
  "pipelineView": "Vista de embudo",
  "listView": "Vista de lista",
  "failedToLoadCRMPipelines": "No se han podido cargar los embudos de CRM.",
  "loadingPipeline2": "Cargando embudo...",
  "loadingInteractions": "Cargando interacciones...",
  "noInteractionsLoggedYet": "Aún no hay interacciones registradas.",
  "loggedBy": "Registrado por:",
  "active2": "Activas (",
  "noActiveSequences": "Sin secuencias activas",
  "startSequence": "Iniciar secuencia",
  "someSequencesArePausedOrFailed": "Algunas secuencias están pausadas o han fallado.",
  "nextRun": "Próxima ejecución:",
  "failed": "Fallo:",
  "stageGoal": "Objetivo de etapa",
  "noStageGoalForThisStage": "Esta etapa no tiene objetivo",
  "logInteraction": "Registrar interacción",
  "interactionType": "Tipo de interacción",
  "selectAType": "Selecciona un tipo",
  "phoneCall": "Llamada telefónica",
  "direction": "Dirección",
  "selectDirection": "Selecciona una dirección",
  "outbound": "Saliente",
  "inbound": "Entrante",
  "occurredAt": "Fecha y hora",
  "addAnyRelevantNotes": "Añade las notas pertinentes",
  "saveInteraction": "Guardar interacción",
  "meetingNoteUnavailable": "Nota de reunión no disponible",
  "thisInteractionIsMissingAMeetingLink": "Esta interacción no tiene un enlace a una reunión.",
  "weCouldNotLoadThisMeetingNoteItMayHaveBeenDeletedOrYouMayNotHaveAccess": "No se ha podido cargar la nota de reunión. Puede haberse eliminado o puede que no tengas acceso.",
  "sequenceStarted": "Secuencia iniciada",
  "failedToStartSequence": "No se ha podido iniciar la secuencia",
  "interactionLogged": "Interacción registrada",
  "failedToLogInteraction": "No se ha podido registrar la interacción",
  "leadStageUpdated": "Etapa del contacto actualizada",
  "failedToUpdateStage": "No se ha podido actualizar la etapa",
  "unableToChangePipeline": "No se puede cambiar el embudo",
  "theSelectedPipelineHasNoOpenStagesAvailable": "El embudo seleccionado no tiene etapas abiertas disponibles.",
  "failedToUpdatePipeline": "No se ha podido actualizar el embudo",
  "loadingLead": "Cargando contacto…",
  "leadNotFound": "No se ha encontrado el contacto.",
  "backToCRM": "Volver a CRM",
  "failedToLoadLead": "No se ha podido cargar el contacto.",
  "noLeadDataAvailable": "No hay datos del contacto disponibles.",
  "tags2": "Etiquetas:",
  "addTagsSeparatedByCommas": "Añade etiquetas separadas por comas",
  "startSequence2": "Iniciar secuencia",
  "addTask": "Añadir tarea",
  "viewCompletedTasks": "Ver tareas completadas",
  "noActiveTasksForThisLead": "Este contacto no tiene tareas activas.",
  "overdue2": "Vencida",
  "today2": "Hoy",
  "interactions": "Interacciones",
  "logInteraction2": "+ Registrar interacción",
  "failedToLoadInteractions": "No se han podido cargar las interacciones.",
  "leadOverview": "Resumen del contacto",
  "editLead": "Editar contacto",
  "loadingConnections": "Cargando vínculos...",
  "source3": "Origen:",
  "email2": "Correo:",
  "phone2": "Teléfono:",
  "company2": "Empresa:",
  "leadValue2": "Valor del contacto:",
  "assignedTo2": "Asignado a:",
  "stage3": "Etapa:",
  "membershipInterest2": "Interés de afiliación:",
  "interests2": "Intereses:",
  "cRMLead": "Contacto de CRM",
  "sequence": "Secuencia",
  "chooseASequence": "Elige una secuencia",
  "startTimeOptional": "Hora de inicio (opcional)",
  "start": "Iniciar",
  "completedTasks": "Tareas completadas",
  "noCompletedTasksForThisLead": "Este contacto no tiene tareas completadas.",
  "reopen": "Reabrir",
  "moveLeadToThisStage": "¿Mover el contacto a esta etapa?",
  "generatingSuggestions": "Generando sugerencias...",
  "clickRefreshToGetAIPoweredNextSteps": "Pulsa Actualizar para obtener próximos pasos con IA",
  "generateDraft": "Generar borrador",
  "failedToGenerateAISummaryPleaseTryAgain": "No se ha podido generar el resumen con IA. Inténtalo de nuevo.",
  "justNow": "Ahora mismo",
  "selectLeadsToManage": "Selecciona los contactos que quieres gestionar",
  "noPipeline": "Sin embudo",
  "loading": "Cargando…",
  "calls": "Llamadas",
  "emails": "Correos",
  "meetings": "Reuniones",
  "wonDeals": "Operaciones ganadas",
  "slow": "Lenta",
  "fast": "Rápida",
  "converted": "Convertido",
  "members": "Socios",
  "nA": "No disponible",
  "failedToSaveStageAutomation": "No se ha podido guardar la automatización de etapa",
  "failedToRemoveStageAutomation": "No se ha podido eliminar la automatización de etapa",
  "failedToSavePipelineStages": "No se han podido guardar las etapas del embudo",
  "failedToDeletePipeline": "No se ha podido eliminar el embudo",
  "userAssignment": "Asignación de usuario",
  "task": "Tarea",
  "cannotDeleteThisStageBecauseItHasLeadsAssigned": "No se puede eliminar esta etapa porque tiene contactos asignados.",
  "closedWonAndClosedLostStagesCannotBeRemoved": "No se pueden eliminar las etapas de operaciones ganadas y perdidas.",
  "closedStagesMustBePositionedAtTheEndOfThePipeline": "Las etapas cerradas deben situarse al final del embudo.",
  "pipelineMustIncludeExactlyOneClosedWonAndOneClosedLostStage": "El embudo debe incluir exactamente una etapa ganada y una perdida.",
  "pleaseProvideNamesForAllOpenStages": "Introduce nombres para todas las etapas abiertas.",
  "cannotDeleteAPipelineThatHasLeadsPleaseMoveOrRemoveLeadsFirst": "No se puede eliminar un embudo con contactos. Primero mueve o elimina los contactos.",
  "pleaseEnsureThereIsExactlyOneClosedWonAndOneClosedLostStage": "Asegúrate de que haya exactamente una etapa ganada y una perdida.",
  "allActiveStagesNeedAName": "Todas las etapas activas necesitan un nombre.",
  "areYouSureYouWantToDeleteThisPipeline": "¿Seguro que quieres eliminar este embudo?",
  "defineWhoShouldWorkOnTheseLeads": "Define quién debe trabajar con estos contactos",
  "automaticallyMoveLeadsToTheNextStageOnceTheseGoalsAreMet": "Mueve automáticamente los contactos a la siguiente etapa cuando se cumplan estos objetivos",
  "createTasksForYourTeamToComplete": "Crea tareas para tu equipo",
  "automaticallySendEmailSequencesToALeadOnceItMovesIntoThisStage": "Envía automáticamente secuencias de correo a un contacto cuando llegue a esta etapa",
  "terminal": "Terminal",
  "failedToLoadCRMTarget": "No se ha podido cargar el objetivo de CRM",
  "failedToCreatePipeline": "No se ha podido crear el embudo",
  "failedToSaveCRMTarget": "No se ha podido guardar el objetivo de CRM",
  "noPreviewAvailable": "No hay vista previa disponible",
  "pleaseEnterATemplateName": "Introduce un nombre para la plantilla",
  "editTemplate": "Editar plantilla",
  "templateUpdated": "Plantilla actualizada",
  "templateCreated": "Plantilla creada",
  "areYouSureYouWantToDeleteThisTemplate": "¿Seguro que quieres eliminar esta plantilla?",
  "notSet": "Sin establecer",
  "end": "Fin",
  "pleaseSelectASource": "Selecciona un origen.",
  "pleaseSelectAPipelineAndStage": "Selecciona un embudo y una etapa.",
  "missingClubContext": "No se ha podido determinar el club.",
  "editLead2": "Editar contacto",
  "addNewLead": "Añadir nuevo contacto",
  "selectAMembershipType": "Selecciona un tipo de afiliación",
  "searchLeadsByNameEmailPhone": "Buscar contactos por nombre, correo o teléfono",
  "searchMembersByNameEmailPhoneMembership": "Buscar socios por nombre, correo, teléfono o número de socio",
  "selectAResult": "Selecciona un resultado",
  "typeAtLeast2CharactersToSearch": "Escribe al menos 2 caracteres para buscar",
  "unnamed": "Sin nombre",
  "noEmail": "Sin correo",
  "noContact": "Sin datos de contacto",
  "unknown": "Desconocido",
  "noNote": "Sin nota",
  "saving": "Guardando…",
  "saveChanges": "Guardar cambios",
  "createLead": "Crear contacto",
  "noActivity": "Sin actividad",
  "yourLead": "tu contacto",
  "creating": "Creando…",
  "createMember": "Crear socio",
  "system": "Sistema",
  "voiceRecognitionIsNotSupportedByYourBrowser": "Tu navegador no admite el reconocimiento de voz.",
  "failedToLogActivityPleaseTryAgain": "No se ha podido registrar la actividad. Inténtalo de nuevo.",
  "pleaseEnterCampaignTitleAndSubject": "Introduce el título y el asunto de la campaña",
  "editCampaign": "Editar campaña",
  "createEmailCampaign": "Crear campaña de correo",
  "updateCampaign": "Actualizar campaña",
  "errorSavingCampaignPleaseTryAgain": "Error al guardar la campaña. Inténtalo de nuevo.",
  "errorDuplicatingCampaignPleaseTryAgain": "Error al duplicar la campaña. Inténtalo de nuevo.",
  "errorDeletingCampaignPleaseTryAgain": "Error al eliminar la campaña. Inténtalo de nuevo.",
  "selectProspectsToAddToCRM": "Selecciona los prospectos que quieres añadir a CRM",
  "unknownStaff": "Personal desconocido",
  "pleaseTryAgain": "Inténtalo de nuevo.",
  "inactive": "Inactivo",
  "noPreviewAvailable2": "No hay vista previa disponible.",
  "step": "Paso",
  "errorSavingSequence": "Error al guardar la secuencia",
  "saving2": "Guardando...",
  "areYouSureYouWantToArchiveThisSequence": "¿Seguro que quieres archivar esta secuencia?",
  "analyticsViewComingSoon": "La vista de análisis estará disponible próximamente.",
  "pleaseFillInTheRequiredFields": "Completa los campos obligatorios",
  "errorSavingWorkflowPleaseTryAgain": "Error al guardar el flujo. Inténtalo de nuevo.",
  "paused": "Pausada",
  "editWorkflow": "Editar flujo",
  "createNewWorkflow": "Crear nuevo flujo",
  "updateWorkflow": "Actualizar flujo",
  "meetingNotes": "Notas de reunión",
  "manualUI": "Interfaz manual",
  "noDueDate": "Sin fecha de vencimiento",
  "unknownTime": "Hora desconocida",
  "noSubject": "(Sin asunto)",
  "interaction": "Interacción",
  "failed2": "Fallida",
  "anErrorOccurredWhileLoggingTheInteraction": "Se ha producido un error al registrar la interacción.",
  "failedToLoadTasks": "No se han podido cargar las tareas",
  "updatingLeadPipeline": "Actualizando el embudo del contacto",
  "noNotesYet": "Aún no hay notas.",
  "upcoming2": "Próximas",
  "completed2": "Completadas",
  "all": "Todas",
  "noLeadAssociated": "Sin contacto asociado",
  "noDescription": "Sin descripción",
  "unnamedLead": "Contacto sin nombre",
  "teamMember": "Miembro del equipo",
  "assignedUser": "Usuario asignado",
  "rescheduleTask": "Reprogramar tarea",
  "receivedEmail": "Correo recibido",
  "receivedSMS": "SMS recibido",
  "receivedEmailOrSMS": "Correo o SMS recibido",
  "taskCompleted": "Tarea completada",
  "draft": "Borrador",
  "cancelled": "Cancelada",
  "pending": "Pendiente",
  "scheduled2": "Programada",
  "skipped": "Omitida",
  "running": "En ejecución",
  "readOnly": "Solo lectura",
  "unableToCompleteThisActionPleaseTryAgain": "No se ha podido completar esta acción. Inténtalo de nuevo.",
  "taskMovedToDate": "Tarea trasladada al {date}.",
  "scheduledForDate": "Programada para el {date}.",
  "movedCountLeadSToPipeline": "Se han movido {count} contacto(s) a {pipeline}",
  "addedCountProspectSToCRM": "Se han añadido {count} prospecto(s) a CRM",
  "revertedCountLeadSBackToProspects": "Se han devuelto {count} contacto(s) a prospectos",
  "sendEmailStepStepRequiresAnEmailTemplate": "El paso {step} de envío de correo requiere una plantilla",
  "deleteName": "¿Eliminar {name}?",
  "editName": "Editar {name}",
  "duplicateName": "Duplicar {name}",
  "archiveName": "Archivar {name}",
  "selectName": "Seleccionar {name}",
  "moveName": "Mover {name}",
  "firstName2": "Nombre",
  "lastName2": "Apellidos",
  "senderName2": "Nombre del remitente",
  "companyName": "Nombre de la empresa",
  "notAuthorised": "Sin autorización",
  "youDoNotHavePermissionToPerformThisAction": "No tienes permiso para realizar esta acción.",
  "pause": "Pausar",
  "resume": "Reanudar",
  "dragCancelled": "Movimiento cancelado.",
  "liftedItemAtPositionPositionUseArrowKeysToMoveSpaceToDropOrEscapeToCancel": "Elemento seleccionado en la posición {position}. Usa las flechas para mover, Espacio para soltar o Escape para cancelar.",
  "movingToPositionPosition": "Moviendo a la posición {position}.",
  "droppedAtPositionPosition": "Soltado en la posición {position}.",
  "pressSpaceToPickUpAnItemUseArrowKeysToMoveItSpaceToDropOrEscapeToCancel": "Pulsa Espacio para seleccionar un elemento. Usa las flechas para moverlo, Espacio para soltarlo o Escape para cancelar.",
  "startDate": "Fecha de inicio",
  "duplicate": "Duplicar",
  "archive": "Archivar",
  "selectAll": "Seleccionar todo",
  "selectProspect": "Seleccionar prospecto",
  "noDataAvailable": "No hay datos disponibles",
  "errorGeneratingEmailDraftPleaseTryAgain": "Error al generar el borrador de correo. Inténtalo de nuevo.",
  "open": "Abierta",
  "countHoursAgo": "Hace {count} horas",
  "countDaysAgo": "Hace {count} días",
  "generateInsights": "Generar información",
  "thisLeadHasAlreadyBeenConverted": "Este contacto ya se ha convertido en socio.",
  "aMemberWithTheseContactDetailsAlreadyExists": "Ya existe un socio con estos datos de contacto.",
  "selectAStageInTheSelectedPipeline": "Selecciona una etapa del embudo seleccionado.",
  "chooseAnActiveSalesTeamMember": "Elige un miembro activo del equipo de ventas.",
  "thereIsNoImportToUndo": "No hay ninguna importación que deshacer.",
  "taskTypeAndNameAreRequired": "El tipo y el nombre de la tarea son obligatorios.",
  "sequenceHasNoStepsAddStepsBeforeEnrollingLeads": "La secuencia no tiene pasos. Añade pasos antes de inscribir contactos.",
  "sequenceIsArchivedActivateItBeforeEnrollingLeads": "La secuencia está archivada. Actívala antes de inscribir contactos.",
  "theSequenceMustBeActiveBeforeEnrollingLeads": "La secuencia debe estar activa antes de inscribir contactos.",
  "sequenceNotFound": "No se ha encontrado la secuencia.",
  "pipelineNotFound": "No se ha encontrado el embudo.",
  "taskNotFound": "No se ha encontrado la tarea.",
  "checkTheRequiredFieldsAndTryAgain": "Revisa los campos obligatorios e inténtalo de nuevo.",
  "selectAValidStage": "Selecciona una etapa válida.",
  "enterAnAIPrompt": "Introduce una instrucción para la IA.",
  "chooseEmailOrSMS": "Elige correo electrónico o SMS.",
  "golfVisitorLog": "Registro de visitantes de golf",
  "racquetVisitorLog": "Registro de visitantes de deportes de raqueta",
  "spaVisitorLog": "Registro de visitantes del spa",
  "fitnessVisitorLog": "Registro de visitantes del gimnasio",
  "diningVisitorLog": "Registro de visitantes de restauración",
  "visitorLog": "Registro de visitantes",
  "settingsLeads": "Contactos potenciales",
  "settingsRedesign0": "Configuración del CRM",
  "settingsRedesign1": "Gestiona tu equipo de ventas, los embudos y los objetivos.",
  "settingsRedesign2": "Equipo de ventas",
  "settingsRedesign3": "Añade personal existente y asígnale un rol de CRM. Esto no cambia su puesto ni su acceso al club.",
  "settingsRedesign4": "Añadir personal",
  "settingsRedesign5": "Buscar por nombre",
  "settingsRedesign6": "Filtrar por rol",
  "settingsRedesign7": "Todos los roles",
  "settingsRedesign8": "Responsables de ventas",
  "settingsRedesign9": "Vendedores",
  "settingsRedesign10": "Vendedor",
  "settingsRedesign12": "Todas las tareas del CRM del club",
  "settingsRedesign13": "Solo las tareas asignadas",
  "settingsRedesign14": "Rol de CRM",
  "settingsRedesign15": "resultados",
  "settingsRedesign16": "Borrar filtros",
  "settingsRedesign17": "Reintentar",
  "settingsRedesign18": "No hay personal que coincida.",
  "settingsRedesign19": "Rol desconocido",
  "settingsRedesign20": "Cambiar el rol de CRM",
  "settingsRedesign21": "Esta persona podrá acceder a todas las tareas del CRM del club.",
  "settingsRedesign22": "Esta persona solo podrá ver sus tareas asignadas.",
  "settingsRedesign23": "Aplicar rol",
  "settingsRedesign24": "Acciones del personal",
  "settingsRedesign25": "Reasignar trabajo",
  "settingsRedesign26": "Quitar del equipo de ventas",
  "settingsRedesign27": "Añadir personal seleccionado",
  "settingsRedesign28": "Reasignar y quitar",
  "settingsRedesign29": "Buscar personal",
  "settingsRedesign30": "Buscar por nombre, departamento o puesto",
  "settingsRedesign31": "personas seleccionadas",
  "settingsRedesign32": "Ya añadido",
  "settingsRedesign33": "Se requiere una identidad autenticada existente",
  "settingsRedesign34": "Cargando personal…",
  "settingsRedesign35": "tareas abiertas",
  "settingsRedesign36": "contactos potenciales activos",
  "settingsRedesign37": "Cargando trabajo…",
  "settingsRedesign38": "Se conservan su ficha de personal y su historial de trabajo completado. El trabajo pendiente debe transferirse antes de quitar a esta persona.",
  "settingsRedesign39": "Buscar la persona destinataria",
  "settingsRedesign40": "Nueva persona asignada a las tareas",
  "settingsRedesign41": "Nuevo responsable de los contactos potenciales",
  "settingsRedesign42": "Selecciona un destino",
  "settingsRedesign43": "Incluir la responsabilidad de los contactos potenciales activos",
  "settingsRedesign44": "No se modificarán las tareas completadas ni los contactos potenciales cerrados.",
  "settingsRedesign45": "Actualizar vista previa",
  "settingsRedesign46": "Selecciona personal para continuar.",
  "settingsRedesign47": "Reglas de tareas",
  "settingsRedesign48": "Los responsables ven todas las tareas del CRM del club. Los vendedores solo ven las suyas. Los responsables pueden ver las tareas sin asignar.",
  "settingsRedesign49": "Gestionar reglas",
  "settingsRedesign50": "Guardar reglas",
  "settingsRedesign51": "Visibilidad de las tareas",
  "settingsRedesign52": "Fijada por el rol",
  "settingsRedesign53": "Asignación predeterminada",
  "settingsRedesign54": "Responsable predeterminado de las nuevas tareas",
  "settingsRedesign55": "Creador de la tarea",
  "settingsRedesign56": "Responsable del contacto potencial",
  "settingsRedesign57": "Responsable de ventas alternativo",
  "settingsRedesign58": "Sin asignar — visible para responsables",
  "settingsRedesign59": "Las nuevas tareas se asignan a su creador si cumple los requisitos. En caso contrario, quedan sin asignar.",
  "settingsRedesign60": "Las nuevas tareas se asignan al responsable del contacto si cumple los requisitos; después, al responsable de ventas alternativo. Sin ninguno de ellos, quedan sin asignar.",
  "settingsRedesign61": "Estos valores solo se aplican a nuevas tareas. Se conservan las asignaciones existentes y las asignaciones explícitas autorizadas. Los vendedores solo pueden crear tareas para sí mismos.",
  "settingsRedesign62": "Guardar cambios",
  "settingsRedesign64": "Cambios sin guardar",
  "settingsRedesign65": "¿Quieres guardar los cambios antes de cerrar?",
  "settingsRedesign66": "Seguir editando",
  "settingsRedesign67": "Descartar cambios",
  "settingsRedesign68": "Objetivos",
  "settingsRedesign69": "Introduce un objetivo entero positivo.",
  "settingsRedesign70": "La etiqueta es obligatoria.",
  "settingsRedesign71": "Editar embudo",
  "settingsRedesign72": "Crear embudo",
  "settingsRedesign73": "Guardar embudo",
  "settingsRedesign74": "Orden de clasificación",
  "settingsRedesign75": "Introduce nombres de etapas únicos, un nombre de embudo y un orden válido.",
  "settingsRedesign76": "Nombre de la etapa",
  "settingsRedesign77": "Color de la etapa",
  "settingsRedesign78": "Resultado de la etapa",
  "settingsRedesign79": "Ganado",
  "settingsRedesign80": "Perdido",
  "settingsRedesign81": "Subir etapa",
  "settingsRedesign82": "Bajar etapa",
  "settingsRedesign83": "Quitar etapa",
  "settingsRedesign84": "No se pueden cambiar los resultados de etapas con registros. Mueve los registros a una etapa con el mismo resultado antes de quitarla.",
  "settingsRedesign85": "contactos deben trasladarse antes de quitar esta etapa.",
  "settingsRedesign86": "Etapa de destino",
  "settingsRedesign87": "Conservar etapa",
  "settingsRedesign88": "Vista previa del embudo",
  "settingsRedesign89": "Mantén una etapa Ganado y una Perdido al final. Arrastra las etapas o usa los botones de flecha para reordenarlas.",
  "settingsRedesign90": "Guardado",
  "settingsRedesign93": "Los cambios están desactualizados. Actualiza la vista previa y revisa el trabajo antes de confirmar.",
  "settingsRedesign94": "Este registro ha cambiado. Cierra y vuelve a abrir el editor antes de reintentarlo.",
  "settingsRedesign95": "Selecciona primero otro responsable de ventas alternativo en las reglas de tareas.",
  "settingsRedesign96": "Han cambiado los requisitos del personal. Actualiza el selector y revisa la selección.",
  "settingsRedesign97": "Parte del personal seleccionado ya pertenece al equipo de ventas. Actualiza y vuelve a intentarlo.",
  "settingsRedesign98": "Selecciona un destino válido para cada tipo de trabajo pendiente.",
  "settingsRedesign99": "Los registros existentes impiden cambiar este resultado. Consérvalo para mantener los informes.",
  "settingsRedesign100": "Selecciona una etapa de este embudo con el mismo resultado.",
  "settingsRedesign101": "Los permisos del CRM no están disponibles. Inténtalo de nuevo.",
  "settingsStageAutomations": "Automatizaciones de etapas",
  "settingsUnableToLoadSettings": "No se ha podido cargar la configuración.",
  "settingsChangesNotSaved": "Cambios sin guardar",
  "settingsAddCountStaff": "Añadir personal ({count})",
  "settingsReplacementFallbackManager": "Responsable de ventas alternativo de sustitución",
  "settingsStageAssignmentDefaultsWillAlsoTransferToTheNewLeadOwner": "valores de asignación de etapas también se transferirán al nuevo responsable.",
  "settingsUseAssignmentDefault": "Usar la asignación predeterminada",
  "settingsNoTaskAccess": "Sin acceso a tareas",
  "settingsNoEligibleStaffAreAvailable": "No hay personal que cumpla los requisitos."
}
